<script lang="ts">

    import { afterUpdate } from 'svelte';
    import { storeNumberEnterprise, storeNumberMember, storeNumberPartner, storeLanguage, lang_fr } from '../scripts/store';
    import { isElementInViewport } from '../scripts/utils';

    let digitEnterprise: number = 0;
    let digitMember: number = 0;
    let digitPartner: number = 0;
    let isFirstDisplay: boolean = true;
    let numberPartner: number = 0;

    afterUpdate(() => {
        storeNumberPartner.subscribe(data => {
            numberPartner = data;
            incrementDigits();
        })
    })
    
    /**
     * incrementDigits
     * Incrément visuel des chiffres
     */
    function incrementDigits() {
        const elementDigitEnterprise = document.getElementById('idDigitEnterprise');
        if (isElementInViewport(elementDigitEnterprise) && isFirstDisplay) {
            isFirstDisplay = false;
            let incrDigitEnterprise: number = digitEnterprise;
            let continuDigitEnterprise: boolean = true;
            let delayEnterprise: number = 0;
            while (continuDigitEnterprise) {
                digitEnterprise = 0;
                incrDigitEnterprise = incrDigitEnterprise + 10;
                delayEnterprise = 400 + (incrDigitEnterprise * 10);
                if (incrDigitEnterprise <= $storeNumberEnterprise) {
                    setTimeout(() => {digitEnterprise = digitEnterprise + 10;}, delayEnterprise);    
                } else {
                    setTimeout(() => {digitEnterprise = $storeNumberEnterprise;}, delayEnterprise);
                    continuDigitEnterprise = false;
                }
            }
            let incrDigitMember: number = digitMember;
            let continuDigitMember: boolean = true;
            let delayMember: number = 0;
            while (continuDigitMember) {
                digitMember = 0;
                incrDigitMember = incrDigitMember + 10;
                delayMember = 400 + (incrDigitMember * 10);
                if (incrDigitMember <= $storeNumberMember) {
                    setTimeout(() => {digitMember = digitMember + 10;}, delayMember);
                } else {
                    setTimeout(() => {digitMember = $storeNumberMember;}, delayMember);
                    continuDigitMember = false;
                }
            }
            let incrDigitPartner: number = digitPartner;
            let continuDigitPartner: boolean = true;
            let delayPartner: number = 0;
            while (continuDigitPartner) {
                digitPartner = 0;
                incrDigitPartner = incrDigitPartner + 1;
                delayPartner = 400 + (incrDigitPartner * 200);
                if (incrDigitPartner <= numberPartner) {
                    setTimeout(() => {digitPartner = digitPartner + 1;}, delayPartner);    
                } else {
                    setTimeout(() => {digitPartner = numberPartner;}, delayPartner);    
                    continuDigitPartner = false;
                }
            }
        }
    }

</script>
    
<style lang="scss">

    .homekeynumber {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 550px;
        background-image: url("../assets/images/Collectif-1920-1080-px-4.png");
        font-weight: 500;
        color: $color_white;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__digit {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            width: 350px;
            margin: 20px 0 20px 0;
            &__icon {
                height: 80px;
            }
            &__text {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                padding: 0 0 0 40px;
                &__number {
                    font-weight: 600;
                    font-size: 50px;
                }
            }
        }
    }

    @include large {
        .homekeynumber {
            flex-direction: row;
            height: 430px;
            &__bloc {
                flex-direction: row;
            }
            &__digit {
                margin: 0;
                width: auto;
                &__icon {
                    transition: all 0.8s;
                    &:hover {
                        transform: translateY(-22px) scale(1.2);
                    }
                }
            }
        }
    }

</style>

<svelte:window on:scroll={incrementDigits} />
<div id="idHomeKeyNumber" class="homekeynumber">
    <div class="bloc homekeynumber__bloc">
        <div id="idDigitEnterprise" class="homekeynumber__digit">
            <img class="homekeynumber__digit__icon" alt="entreprises" src="../assets/images/digit-enterprise.png">
            <div class="homekeynumber__digit__text">
                <div class="homekeynumber__digit__text__number">{digitEnterprise}&nbsp+</div>
                <div>
                    {#if ($storeLanguage == $lang_fr)}
                    Entreprises&nbsp;membres
                    {:else}
                    Member&nbsp;companies
                    {/if}
                </div>
            </div>
        </div>
        <div class="homekeynumber__digit">
            <img class="homekeynumber__digit__icon" alt="membres" src="../assets/images/digit-member.png">
            <div class="homekeynumber__digit__text">
                <div class="homekeynumber__digit__text__number">{digitMember}&nbsp+</div>
                <div>
                    {#if ($storeLanguage == $lang_fr)}
                    Membres&nbsp;actifs
                    {:else}
                    Active&nbsp;members
                    {/if}
                </div>
            </div>
        </div>
        <div class="homekeynumber__digit">
            <img class="homekeynumber__digit__icon" alt="partenaires" src="../assets/images/digit-partner.png">
            <div class="homekeynumber__digit__text">
                <div class="homekeynumber__digit__text__number">{digitPartner}</div>
                <div>
                    {#if ($storeLanguage == $lang_fr)}
                    Partenaires&nbsp;investis
                    {:else}
                    Invested&nbsp;partners
                    {/if}
                </div>
            </div>
        </div>    
    </div>
</div>
